import clsx from 'clsx'
import Image from 'next/image'
import { type MouseEvent, type PointerEvent, type Ref, type TouchEvent, type WheelEvent } from 'react'

import closeIcon from 'assets/svg/close-2.svg'
import zoomIcon from 'assets/svg/zoom.svg'

import { Icon } from '@/shared/ui/icon'

import { isReviewVideo, resolveReviewMediaUrl } from '../../lib/media'
import { ReviewMediaItem } from '../../model/types'

import styles from './GalleryMedia.module.scss'

export const GalleryMedia = ({
	item,
	className,
	onClick,
	showZoomButton,
	isZoomButtonActive = false,
	onZoomClick,
	isZoomed = false,
	imageRef,
	onPointerDown,
	onPointerMove,
	onPointerUp,
	onWheel,
	onTouchStart,
	onTouchMove,
	onTouchEnd
}: {
	item: ReviewMediaItem
	className?: string
	onClick?: (event: MouseEvent<HTMLDivElement>) => void
	showZoomButton?: boolean
	isZoomButtonActive?: boolean
	onZoomClick?: () => void
	isZoomed?: boolean
	imageRef?: Ref<HTMLImageElement>
	onPointerDown?: (event: PointerEvent<HTMLDivElement>) => void
	onPointerMove?: (event: PointerEvent<HTMLDivElement>) => void
	onPointerUp?: (event: PointerEvent<HTMLDivElement>) => void
	onWheel?: (event: WheelEvent<HTMLDivElement>) => void
	onTouchStart?: (event: TouchEvent<HTMLDivElement>) => void
	onTouchMove?: (event: TouchEvent<HTMLDivElement>) => void
	onTouchEnd?: (event: TouchEvent<HTMLDivElement>) => void
}) => {
	const src = resolveReviewMediaUrl(item.src)
	const isVideo = isReviewVideo(item.src)

	return (
		<div
			className={clsx(styles.root, isVideo && styles.video, isZoomed && styles._zoomed, className)}
			onClick={onClick}
			onPointerDown={onPointerDown}
			onPointerMove={onPointerMove}
			onPointerUp={onPointerUp}
			onPointerCancel={onPointerUp}
			onWheel={onWheel}
			onTouchStart={onTouchStart}
			onTouchMove={onTouchMove}
			onTouchEnd={onTouchEnd}>
			{isVideo ? (
				<video src={src} controls playsInline preload="metadata" aria-label={`Видео из отзыва ${item.review.author}`}>
					<track kind="captions" />
				</video>
			) : (
				<>
					<Image className={styles.backdrop} src={src} alt="" fill aria-hidden="true" />
					<Image ref={imageRef} className={styles.image} src={src} alt={`Фото из отзыва ${item.review.author}`} fill />
					{showZoomButton && (
						<button
							type="button"
							className={styles.zoomButton}
							onPointerDown={event => {
								event.stopPropagation()
							}}
							onClick={event => {
								event.stopPropagation()
								onZoomClick?.()
							}}
							aria-label={isZoomButtonActive ? 'Уменьшить фото' : 'Увеличить фото'}>
							<Icon icon={isZoomButtonActive ? closeIcon : zoomIcon} width={24} height={24} />
						</button>
					)}
				</>
			)}
		</div>
	)
}
